import React from 'react';

const NativeBirthTimeSelect = ({
  value = '',
  options = [],
  onChange,
  label = '請選擇出生時辰',
  hasError = false,
}) => (
  <div className="tl-native-birth-time-field">
    <select
      className={`tl-native-birth-time-select ${value ? 'has-value' : ''}`.trim()}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      aria-label={label}
      aria-invalid={hasError}
    >
      <option value="">請選擇出生時辰</option>
      {options.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </select>
  </div>
);

export default NativeBirthTimeSelect;
